<div>
	@if (editMode() === 'full') {
	<lib-card [isInDialog]="isInDialog()" [isForm]="true">
		<ui-text-form-field
			[title]="'Session title'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-date-form-field
			class="push-top-md"
			[title]="'Session date'"
			[isRequired]="true"
			[valueAsSignal]="form.date"
			[isInDialog]="isInDialog()"
		></ui-date-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Notes'"
			[valueAsSignal]="form.notes"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>

		<ui-form-save-button
			[isInDialog]="isInDialog()"
			[title]="'Edit'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
	}
</div>

@if (sessionItem().sessionType === 'workout') {
<div [class.push-top]="editMode() === 'full'">
	<lib-divider class="push-top push-bottom" [layout]="'withContent'">Workout record</lib-divider>
	<div>
		<div>
			@if (form.state(); as stateItems) { @for (stateItem of stateItems; track stateItem.id; let first = $first;
			let last = $last) {
			<lib-card [class.push-top]="!first">
				<div libFlexRow [libFlexRowGap]="'8px'">
					@if (stateItem.indexAndVariant) {
					<div libFlexColumn libText3>{{ stateItem.indexAndVariant }}.</div>
					}
					<div libFlexColumn libText2>
						{{ stateItem.title }}
					</div>
				</div>
				<div>
					@for (nestedItem of stateItem.items; track nestedItem.id) {
					<div class="push-top-sm" libFlexRow>
						<div libFlexColumn libFlexFill>
							{{ nestedItem.title }}
						</div>
						<div libFlexColumn>
							<mod-session-compliance
								[result]="nestedItem.result"
								(sessionChange)="handleChangeNestedItemCompliance(nestedItem, $event)"
							></mod-session-compliance>
						</div>
					</div>
					}
				</div>
			</lib-card>
			} @empty {
			<lib-divider class="push-top push-bottom"></lib-divider>
			<lib-message [type]="'noData'">This workout contains no exercises</lib-message>
			} }
		</div>
	</div>
</div>
}
